function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMailRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.121 19a2.99 2.99 0 01-2.121.877A2.988 2.988 0 0113.879 19L3 8.121v16.88a2 2 0 002 2h22a2 2 0 002-2V8.12l-10.879 10.88z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.707 17.586l11.84-11.84A1.99 1.99 0 0027 5H5a1.99 1.99 0 00-1.547.746l11.84 11.84a.999.999 0 001.414 0z",
    fill: props.color
  }));
}

export default SvgIconMailRexFilled;